const routeSettings = {
  PUBLIC_URL: [
    /auth\/\S*/,
    /onboarding\/?\S*/,
    /health/,
    /\/apps\/documents\/\[id\]\/guest-viewer/
  ],
  PUBLIC_PRIVATE_URL: [/404/, /invitation\/\S*/]
}

export default routeSettings
